<!-- components/RechargeModal.vue -->
<template>
    <el-dialog title="充值" :visible.sync="visible" width="400px" :close-on-click-modal="false" @close="handleClose">
        <div class="recharge-container">
            <!-- 支付等待状态 -->
            <div v-if="payingStatus === 'waiting'" class="paying-waiting">
                <div class="waiting-icon">
                    <i class="el-icon-loading"></i>
                </div>
                <div class="waiting-title">等待支付中...</div>
                <div class="waiting-order">订单号：{{ currentOrderNo }}</div>
                <div class="waiting-amount">支付金额：<span class="highlight">¥{{ payAmount.toFixed(2) }}</span></div>
                <div class="waiting-tip">请在新窗口完成支付，支付成功后自动刷新</div>
                <div class="waiting-actions">
                    <el-button type="primary" @click="checkPayStatus">我已完成支付</el-button>
                    <el-button @click="cancelPay">取消支付</el-button>
                </div>
            </div>

            <!-- 正常充值表单 -->
            <div v-else>
                <!-- 余额显示 -->
                <div class="balance-info">
                    <span>当前余额：</span>
                    <span class="balance-amount">¥{{ balance.toFixed(2) }}</span>
                </div>

                <!-- 充值金额选择 -->
                <div class="amount-section">
                    <div class="section-title">充值金额</div>
                    <div class="amount-grid">
                        <div v-for="amt in presetAmounts" :key="amt" class="amount-item" :class="{ active: amount === amt }"
                            @click="amount = amt">
                            ¥{{ amt }}
                        </div>
                    </div>
                    <div class="custom-amount">
                        <el-input v-model="customAmount" placeholder="自定义金额" type="number" :min="minRecharge"
                            @input="handleCustomInput" />
                        <span class="min-tip">最低充值 ¥{{ minRecharge }}</span>
                    </div>
                </div>

                <!-- 支付方式 -->
                <div class="payment-section">
                    <div class="section-title">支付方式</div>
                    <div class="payment-methods">
                        <div class="payment-item active">
                            <i class="el-icon-bank-card"></i>
                            <span>支付宝</span>
                        </div>
                    </div>
                </div>

                <!-- 充值按钮 -->
                  <!-- :disabled="!isAmountValid" -->
                <el-button type="primary" :loading="loading"  @click="handleRecharge">
                    立即充值 ¥{{ finalAmount.toFixed(2) }}
                </el-button>
            </div>
        </div>
    </el-dialog>
</template>

<script>
export default {
    data() {
        return {
            visible: false,
            balance: 0,
            minRecharge: 30,
            presetAmounts: [30, 50, 100, 200, 500],
            amount: 30,
            customAmount: '',
            loading: false,
            pollTimer: null, // 轮询定时器
            currentOrderNo: '', // 当前订单号
            payAmount: 0, // 支付金额
            payingStatus: '' // 支付状态: '' | 'waiting' | 'success'
        }
    },

    computed: {
        userId() {
            return this.$store.getters.getUserId
        },
        finalAmount() {
            return this.customAmount ? Number(this.customAmount) : this.amount
        },
        isAmountValid() {
            return this.finalAmount >= this.minRecharge
        }
    },

    beforeDestroy() {
        this.clearPollTimer()
    },

    methods: {
        async show() {
            this.visible = true
            this.payingStatus = ''
            this.currentOrderNo = ''
            await this.fetchBalance()
        },

        async fetchBalance() {
            if (!this.userId) return
            try {
                const { data } = await this.$http.get(`/RechargeTransaction/balance/${this.userId}`)
                if (data.meta?.status === 200) {
                    this.balance = data.data.balance || 0
                }
            } catch (error) {
                console.error('获取余额失败:', error)
            }
        },

        handleCustomInput(val) {
            if (val) {
                this.amount = null
            }
        },

        async handleRecharge() {
            // if (!this.isAmountValid) {
            //     this.$message.warning(`最低充值金额为${this.minRecharge}元`)
            //     return
            // }

            if (!this.userId) {
                this.$message.error('请先登录')
                return
            }

            this.loading = true
            try {
                // 创建充值订单
                const { data } = await this.$http.post('/recharge/create', {
                    user_id: this.userId,
                    amount: this.finalAmount,
                    return_url: window.location.origin + window.location.pathname,
                    remark: '账户充值'
                })

                if (data.meta?.status === 200) {
                    const { order, payUrl } = data.data
                    this.currentOrderNo = order.order_no
                    this.payAmount = order.amount

                    // 跳转支付宝支付页面
                    if (payUrl) {
                        // 新窗口打开支付宝支付
                        window.open(payUrl, '_blank')
                        // 切换到等待支付状态
                        this.payingStatus = 'waiting'
                        // 开始轮询支付状态
                        this.startPollingPaymentStatus()
                    } else {
                        this.$message.error('获取支付链接失败')
                    }
                } else {
                    this.$message.error(data.meta?.msg || '创建订单失败')
                }
            } catch (error) {
                console.error('充值失败:', error)
                this.$message.error(error.response?.data?.meta?.msg || '充值失败，请稍后重试')
            } finally {
                this.loading = false
            }
        },

        // 清理轮询定时器
        clearPollTimer() {
            if (this.pollTimer) {
                clearInterval(this.pollTimer)
                this.pollTimer = null
            }
        },

        // 开始轮询支付状态
        startPollingPaymentStatus() {
            this.clearPollTimer()
            let pollCount = 0
            const maxPollCount = 60 // 最多轮询60次（约5分钟）

            this.pollTimer = setInterval(async () => {
                pollCount++
                if (pollCount > maxPollCount) {
                    this.clearPollTimer()
                    this.$message.warning('支付状态查询超时，请手动刷新')
                    return
                }

                try {
                    const { data } = await this.$http.get(`/recharge/query/${this.currentOrderNo}`)
                    if (data.meta?.status === 200 && data.data.status === 'success') {
                        this.clearPollTimer()
                        this.payingStatus = 'success'
                        this.$message.success('充值成功！')
                        this.visible = false
                        this.$emit('recharged')
                    }
                } catch (error) {
                    console.error('查询支付状态失败:', error)
                }
            }, 3000) // 每3秒查询一次
        },

        // 手动检查支付状态
        async checkPayStatus() {
            if (!this.currentOrderNo) return

            try {
                const { data } = await this.$http.get(`/recharge/query/${this.currentOrderNo}`)
                if (data.meta?.status === 200 && data.data.status === 'success') {
                    this.clearPollTimer()
                    this.payingStatus = 'success'
                    this.$message.success('充值成功！')
                    this.visible = false
                    this.$emit('recharged')
                } else {
                    this.$message.info('暂未检测到支付成功，请稍后再试')
                }
            } catch (error) {
                console.error('查询支付状态失败:', error)
                this.$message.error('查询失败，请稍后重试')
            }
        },

        // 取消支付
        cancelPay() {
            this.clearPollTimer()
            this.payingStatus = ''
            this.currentOrderNo = ''
        },

        // 弹窗关闭时清理
        handleClose() {
            this.clearPollTimer()
            this.payingStatus = ''
        }
    }
}
</script>

<style scoped>
.recharge-container {
    padding: 20px;
}

.balance-info {
    margin-bottom: 20px;
    font-size: 16px;
}

.balance-amount {
    color: #f56c6c;
    font-size: 24px;
    font-weight: bold;
}

.section-title {
    font-size: 14px;
    color: #909399;
    margin-bottom: 10px;
}

.amount-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 10px;
    margin-bottom: 10px;
}

.amount-item {
    text-align: center;
    padding: 10px;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    cursor: pointer;
    transition: all 0.3s;
}

.amount-item:hover,
.amount-item.active {
    border-color: #409eff;
    color: #409eff;
}

.custom-amount {
    margin: 15px 0;
}

.min-tip {
    font-size: 12px;
    color: #909399;
    margin-left: 10px;
}

.payment-methods {
    display: flex;
    gap: 20px;
    margin: 15px 0;
}

.payment-item {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    padding: 12px;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    cursor: pointer;
    transition: all 0.3s;
}

.payment-item.active {
    border-color: #409eff;
    color: #409eff;
}

.payment-item .el-icon-bank-card {
    font-size: 24px;
}

/* 支付等待状态样式 */
.paying-waiting {
    text-align: center;
    padding: 30px 20px;
}

.waiting-icon {
    font-size: 48px;
    color: #409eff;
    margin-bottom: 20px;
}

.waiting-title {
    font-size: 18px;
    font-weight: bold;
    color: #303133;
    margin-bottom: 15px;
}

.waiting-order {
    font-size: 12px;
    color: #909399;
    margin-bottom: 10px;
}

.waiting-amount {
    font-size: 16px;
    color: #606266;
    margin-bottom: 15px;
}

.waiting-amount .highlight {
    color: #f56c6c;
    font-size: 24px;
    font-weight: bold;
}

.waiting-tip {
    font-size: 13px;
    color: #909399;
    margin-bottom: 25px;
}

.waiting-actions {
    display: flex;
    justify-content: center;
    gap: 15px;
}
</style>